(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));

  // node_modules/graditify-utils/src/utils/price.js
  var require_price = __commonJS({
    "node_modules/graditify-utils/src/utils/price.js"(exports, module) {
      var moneyFormat = "${{amount}}";
      function defaultOption(opt, def) {
        return typeof opt === "undefined" ? def : opt;
      }
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ".");
        decimal = defaultOption(decimal, ",");
        if (isNaN(number) || number == null) {
          return 0;
        }
        number = (number / 100).toFixed(precision);
        const parts = number.split(".");
        const dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          `$1${thousands}`
        );
        const cents2 = parts[1] ? decimal + parts[1] : "";
        return dollars + cents2;
      }
      function caseHandler(element, cents2) {
        let value = "";
        switch (element) {
          case "amount":
            value = formatWithDelimiters(cents2, 2);
            break;
          case "amount_no_decimals":
            value = formatWithDelimiters(cents2, 0);
            break;
          case "amount_with_comma_separator":
            value = formatWithDelimiters(cents2, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents2, 0, ".", ",");
            break;
          default:
            value = "";
        }
        return value;
      }
      var formatMoney = (cents2, format) => {
        if (typeof cents2 === "string") {
          cents2 = cents2.replace(".", "");
        }
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const formatString = format || moneyFormat;
        const value = caseHandler(formatString.match(placeholderRegex)[1], cents2);
        const price = formatString.replace(placeholderRegex, value);
        return `${price.replace("$", "\u20AC")} EUR`;
      };
      module.exports = {
        formatMoney
      };
    }
  });

  // node_modules/graditify-utils/src/utils/query-selector.js
  var require_query_selector = __commonJS({
    "node_modules/graditify-utils/src/utils/query-selector.js"(exports, module) {
      var $Qll4 = (nodes, parent) => [...(parent || document).querySelectorAll(nodes)];
      var $Q3 = (node, parent) => (parent || document).querySelector(node);
      module.exports = {
        $Qll: $Qll4,
        $Q: $Q3
      };
    }
  });

  // node_modules/graditify-utils/src/utils/to-html.js
  var require_to_html = __commonJS({
    "node_modules/graditify-utils/src/utils/to-html.js"(exports, module) {
      var support = () => {
        if (!window.DOMParser) return false;
        const parser = new DOMParser();
        try {
          parser.parseFromString("x", "text/html");
        } catch (err) {
          return false;
        }
        return true;
      };
      var stringToHTML = (str) => {
        if (support()) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(str, "text/html");
          return doc.body;
        }
        const dom = document.createElement("div");
        dom.innerHTML = str;
        return dom;
      };
      module.exports = {
        stringToHTML
      };
    }
  });

  // node_modules/graditify-utils/src/utils/toggle-dataset.js
  var require_toggle_dataset = __commonJS({
    "node_modules/graditify-utils/src/utils/toggle-dataset.js"(exports, module) {
      var { $Q: $Q3 } = require_query_selector();
      var overlayActions2 = (id, active, node) => {
        const idOverlay = `overlay--${id}`;
        const parent = node.parentNode;
        if (!active) {
          const overlay = document.createElement("div");
          overlay.setAttribute("id", idOverlay);
          overlay.classList.add("overlay");
          parent.insertBefore(overlay, node);
          toggleDataActive2(`#${idOverlay}`, `#${id}`, { overlay: true });
        } else {
          parent.removeChild($Q3(`#${idOverlay}`));
        }
      };
      var isActive2 = ({ active }) => active === "true";
      function dataToggle2(node, overlay) {
        const { dataset, id } = node;
        const active = isActive2(dataset);
        if (active) {
          dataset.active = "false";
        } else {
          dataset.active = "true";
        }
        overlay && overlayActions2(id, active, node);
      }
      var toggleDataActive2 = (control, node, config = {}) => {
        if (!$Q3(control)) return;
        const { overlay, closeSelector } = config;
        $Q3(control).addEventListener("click", () => {
          dataToggle2($Q3(node), overlay);
        });
        closeSelector && $Q3(closeSelector).addEventListener(
          "click",
          () => {
            dataToggle2($Q3(node), overlay);
          }
        );
      };
      module.exports = {
        toggleDataActive: toggleDataActive2,
        dataToggle: dataToggle2
      };
    }
  });

  // node_modules/graditify-utils/src/index.js
  var require_src = __commonJS({
    "node_modules/graditify-utils/src/index.js"(exports, module) {
      var { formatMoney } = require_price();
      var { $Q: $Q3, $Qll: $Qll4 } = require_query_selector();
      var { stringToHTML } = require_to_html();
      var { toggleDataActive: toggleDataActive2, dataToggle: dataToggle2 } = require_toggle_dataset();
      module.exports = {
        stringToHTML,
        formatMoney,
        toggleDataActive: toggleDataActive2,
        dataToggle: dataToggle2,
        $Q: $Q3,
        $Qll: $Qll4
      };
    }
  });

  // src/utils/query-selector.js
  var $Qll = (nodes, parent) => [...(parent || document).querySelectorAll(nodes)];
  var $Q = (node, parent) => (parent || document).querySelector(node);

  // src/components/sort-by.js
  var Shopify = window.Shopify;
  Shopify.queryParams = {};
  var defaultSortBy = () => {
    const filterInput = $Qll("#sort-by-js");
    filterInput.forEach((filter) => {
      filter.addEventListener(
        "change",
        ({ target }) => {
          const currentParams = new URLSearchParams(location.search);
          currentParams.set("sort_by", target.value);
          location.search = currentParams.toString();
        }
      );
    });
  };
  (function() {
    if (location.search.length) {
      const params = location.search.substring(1).split("&");
      for (let i = 0; i < params.length; i++) {
        const keyValue = params[i].split("=");
        if (keyValue.length) {
          Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
        }
      }
    }
  })();

  // src/utils/toggle-dataset.js
  var overlayActions = (id, active, node) => {
    const idOverlay = `overlay--${id}`;
    const parent = node.parentNode;
    if (!active) {
      const overlay = document.createElement("div");
      overlay.setAttribute("id", idOverlay);
      overlay.classList.add("overlay");
      parent.insertBefore(overlay, node);
      toggleDataActive(`#${idOverlay}`, `#${id}`, { overlay: true });
    } else {
      parent.removeChild($Q(`#${idOverlay}`));
    }
  };
  var isActive = ({ active }) => active === "true";
  function dataToggle(node, overlay) {
    const { dataset, id } = node;
    const active = isActive(dataset);
    const whatsappButton = $Q(".whatsapp-float");
    if (active) {
      dataset.active = "false";
      document.body.style.overflow = "initial";
      if (whatsappButton) {
        whatsappButton.style.display = "block";
      }
    } else {
      dataset.active = "true";
      document.body.style.overflow = "hidden";
      if (whatsappButton) {
        whatsappButton.style.display = "none";
      }
    }
    if (overlay) overlayActions(id, active, node);
  }
  var toggleDataActive = (control, node, config = {}) => {
    const { overlay, closeSelector, video } = config;
    const controlNode = $Q(control);
    const elementActive = $Q(node);
    const closeNode = $Q(closeSelector);
    if (!controlNode || !elementActive) return;
    controlNode.addEventListener("click", () => {
      dataToggle(elementActive, overlay, video);
    });
    if (closeNode) {
      closeNode.addEventListener(
        "click",
        () => dataToggle(elementActive, overlay)
      );
    }
  };

  // src/utils/quantity-price.js
  function concatRegexp(initial, exp) {
    const formating = Number(exp).toLocaleString("de-DE", { style: "currency", currency: "EUR", minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace("\xA0\u20AC", "");
    return initial.replace(/\d+([.\d+.\d,]+\d{2})?/g, formating);
  }

  // src/components/filters-range.js
  function cents(str, fixed) {
    const number = Number(str) / 100;
    if (fixed) return number.toFixed(2);
    return number;
  }
  var FilterElement = class extends HTMLElement {
    constructor() {
      super();
      this.minValue = $Q(".min-value-js", this);
      this.maxValue = $Q(".max-value-js", this);
      this.progress = $Q(".slider-filter .pro", this);
      this.priceMin = $Q(".price-in input.in-min", this);
      this.priceMax = $Q(".price-in input.in-max", this);
      this.defaultMax = Number(this.priceMax.max);
      this.priceGap = 1e3;
      this.rangeIn = $Qll(".range-in input", this);
    }
    /* static get observedAttributes () {
        return ['']
      }
    
      attributeChangedCallback (name, oldVal, newVal) {
      }
     */
    connectedCallback() {
      this.initialize();
      this.onChangeInput();
    }
    initialize() {
      if (this.priceMin.value) {
        this.progress.style.left = `${this.priceMin.value / this.rangeIn[0].max * 1e4}%`;
        this.progress.style.right = `${100 - this.priceMax.value / this.rangeIn[1].max * 1e4}%`;
      }
    }
    onChangeInput() {
      this.rangeIn.forEach((input) => {
        input.addEventListener("input", (e) => {
          const minVal = Number(this.rangeIn[0].value);
          const maxVal = Number(this.rangeIn[1].value);
          if (maxVal - minVal <= this.priceGap) {
            this.reset(e.target.className);
          } else {
            this.max(maxVal);
            this.min(minVal);
          }
        });
      });
    }
    max(value) {
      const maxIn = cents(value, true);
      this.priceMax.value = maxIn;
      this.maxValue.textContent = concatRegexp("0,00", maxIn);
      this.progress.style.right = `${100 - value / this.defaultMax * 100}%`;
      this.priceMax.dispatchEvent(new Event("change"));
    }
    min(value) {
      const minIn = cents(value, true);
      this.priceMin.value = minIn;
      this.minValue.textContent = concatRegexp("0,00", minIn);
      this.progress.style.left = `${value / this.defaultMax * 100}%`;
      this.priceMin.dispatchEvent(new Event("change"));
    }
    reset(type) {
      if (type === "range-min") {
        this.min(0);
        this.rangeIn[0].value = 0;
      } else {
        this.max(this.defaultMax);
        this.rangeIn[1].value = this.defaultMax;
      }
    }
  };
  (function formatValues() {
    $Qll(".price-in input").forEach(
      (item) => {
        if (item.value.includes(",") || item.value.includes(".")) return;
        item.value = cents(item.value, true);
      }
    );
  })();
  customElements.define("filter-element", FilterElement);

  // src/components/filter-changes.js
  var import_graditify_utils = __toESM(require_src());

  // src/utils/debounce.js
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  // src/components/filter-changes.js
  var filterChange = () => {
    const filterInput = (0, import_graditify_utils.$Qll)(".filter-change-js");
    filterInput.forEach((filter) => {
      filter.addEventListener("change", (ev) => {
        const form = ev.target.closest("form");
        const url = filterFormSubmit(form);
        debounce(() => {
          location.href = url;
        }, 500).bind(void 0)();
      });
    });
  };
  var filterFormSubmit = (filter) => {
    const dataCurrentUrlJs = (0, import_graditify_utils.$Q)(".data-current-url-js", filter);
    const currentUrl = dataCurrentUrlJs.href;
    const sortBy = preserveSortBy(dataCurrentUrlJs);
    const formData = new FormData(filter);
    let formDataEntries = [...formData.entries()];
    if (window.Shopify.queryParams && window.Shopify.queryParams.q) {
      formDataEntries = [["q", window.Shopify.queryParams.q], ...formDataEntries];
    }
    const data = formDataEntries.map(([key, value]) => {
      return `${key}=${value}`;
    });
    if (data.length !== 0) {
      data.push("filter.v.availability=1");
    }
    const uniqueData = [...new Set(data)];
    const paramObj = uniqueData.join("&");
    const nextURL = sortBy == "" ? `${currentUrl}?${paramObj}` : `${currentUrl}?${paramObj}&${sortBy}`;
    history.pushState({}, "", nextURL);
    return nextURL;
  };
  var preserveSortBy = (dataCurrentUrlJs) => {
    const baseURI = dataCurrentUrlJs.baseURI;
    const stringParams = baseURI.replace(dataCurrentUrlJs.href, "");
    const params = stringParams.split("&");
    const sortBy = params.find((el) => !el.includes("filter.v"));
    if (!sortBy || !sortBy.includes("sort_by")) return "";
    return sortBy.replace("?", "");
  };

  // src/templates/collection.js
  var import_graditify_utils2 = __toESM(require_src());
  defaultSortBy();
  filterChange();
  toggleDataActive("#filter-open-js", "#filter", {
    overlay: true,
    closeSelector: ".filter-close-js"
  });
  if (window.location.search.includes("availability")) {
    (0, import_graditify_utils2.$Qll)(".filter-group-label .count").forEach(
      (item) => item.classList.remove("hidden")
    );
  }
})();
